import * as dom from "domvm/dist/dev/domvm.dev.js";
export const el = dom.defineElement;
export const sv = dom.defineSvgElement;
export const view = dom.defineView;
export const create = dom.createView;
export const inject = dom.injectView;
export const KEYED_LIST = dom.KEYED_LIST;

const svgTagName = [
	"animate",
	"animateMotion",
	"animateTransform",
	"circle",
	"clipPath",
	"color-profile",
	"defs",
	"desc",
	"discard",
	"ellipse",
	"feBlend",
	"feColorMatrix",
	"feComponentTransfer",
	"feComposite",
	"feConvolveMatrix",
	"feDiffuseLighting",
	"feDisplacementMap",
	"feDistantLight",
	"feDropShadow",
	"feFlood",
	"feFuncA",
	"feFuncB",
	"feFuncG",
	"feFuncR",
	"feGaussianBlur",
	"feImage",
	"feMerge",
	"feMergeNode",
	"feMorphology",
	"feOffset",
	"fePointLight",
	"feSpecularLighting",
	"feSpotLight",
	"feTile",
	"feTurbulence",
	"filter",
	"foreignObject",
	"g",
	"hatch",
	"hatchpath",
	"image",
	"line",
	"linearGradient",
	"marker",
	"mask",
	"mesh",
	"meshgradient",
	"meshpatch",
	"meshrow",
	"metadata",
	"mpath",
	"path",
	"pattern",
	"polygon",
	"polyline",
	"radialGradient",
	"rect",
	"script",
	"set",
	"solidcolor",
	"stop",
	"style",
	"svg",
	"switch",
	"symbol",
	"text",
	"textPath",
	"title",
	"tspan",
	"unknown",
	"use",
	"view",
];

export function disableHelp() {
	dom.DEVMODE.mutations = false;
	dom.DEVMODE.warnings = false;
	dom.DEVMODE.verbose = false;
	dom.DEVMODE.UNKEYED_INPUT = false;
}

export type VNode = any;
export interface IDomView {
	redraw();
	mount(el: HTMLElement);
}
export interface IDomRender {
	render(view: IDomView, data: any): VNode;
}

export interface IViewHash {
	[name: string]: IDomRender;
}

export function resizer(handler) {
	const resize = (window as any).ResizeObserver;
	const activeHandler = node => {
		const height = node.el.offsetHeight;
		const width = node.el.offsetWidth;
		handler(width, height);
	};

	if (resize) {
		return el("div.dhx-resize-observer", {
			_hooks: {
				didInsert(node) {
					new resize(() => activeHandler(node)).observe(node.el);
				},
			},
		});
	}

	return el("iframe.dhx-resize-observer", {
		_hooks: {
			didInsert(node) {
				node.el.contentWindow.onresize = () => activeHandler(node);
				activeHandler(node);
			},
		},
	});
}

export function xmlToJson(xml) {
	let obj = {};

	if (xml.nodeType === 1) {
		if (xml.attributes.length > 0) {
			obj["@attributes"] = {};
			for (let j = 0; j < xml.attributes.length; j++) {
				const attribute = xml.attributes.item(j);
				obj["@attributes"][attribute.nodeName] = attribute.nodeValue;
			}
		}
	} else if (xml.nodeType === 3) {
		obj = xml.nodeValue;
	}

	if (xml.hasChildNodes()) {
		for (let i = 0; i < xml.childNodes.length; i++) {
			const item = xml.childNodes.item(i);
			const nodeName = item.nodeName;
			if (typeof obj[nodeName] === "undefined") {
				obj[nodeName] = xmlToJson(item);
			} else {
				if (typeof obj[nodeName].push === "undefined") {
					const old = obj[nodeName];
					obj[nodeName] = [];
					obj[nodeName].push(old);
				}
				obj[nodeName].push(xmlToJson(item));
			}
		}
	}
	return obj;
}

export function jsonToVDOM(json) {
	const tag = Object.keys(json)[0];
	const element = json[tag];
	if (Array.isArray(element["#text"])) {
		element["#text"] = element["#text"].join("").trim();
	}
	const children = typeof element["#text"] === "string" ? [element["#text"]] : [];

	for (const child in element) {
		if (element.hasOwnProperty(child) && child !== "@attributes" && child !== "#text") {
			if (Array.isArray(element[child])) {
				for (const t in element[child]) {
					if (element[child].hasOwnProperty(t)) {
						children.push(jsonToVDOM({ [child]: element[child][t] }));
					}
				}
			} else {
				children.push(jsonToVDOM({ [child]: element[child] }));
			}
		}
	}

	if (svgTagName.includes(tag)) {
		return sv(tag, element["@attributes"] ? element["@attributes"] : {}, children);
	} else {
		return el(tag, element["@attributes"] ? element["@attributes"] : {}, children);
	}
}
export function resizeHandler(container, handler) {
	return create({
		render() {
			return resizer(handler);
		},
	}).mount(container);
}

export function awaitRedraw(): Promise<any> {
	return new Promise(res => {
		requestAnimationFrame(() => {
			res();
		});
	});
}
